import { useRef, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useClickOutside } from '../hooks';

interface MenuDropDownProps {
  title: string;
  options: any[];
  to?: string;
  uppercase?: boolean;
  id?: string;
}

const MenuDropDown = ({ options, title, to, uppercase, id }: MenuDropDownProps) => {
  const [showOptions, setShowOptions] = useState(false);
  const dropDownRef = useRef(null);
  useClickOutside(dropDownRef, () => setShowOptions(false));

  return (
    <div className="w-full md:w-auto md:h-full flex flex-col items-center justify-center relative">
      <div className={`flex md:h-full w-full ${showOptions ? 'items-start' : 'items-center'} justify-center`}>
        <div ref={dropDownRef} className="group w-full h-full flex text-sm md:justify-center md:items-center">
          <div className={`w-full flex flex-grow gap-2 whitespace-pre-wrap md:whitespace-nowrap md:items-center`}>
            {to ? (
              <Link id={id} to={to} className={`${uppercase && 'uppercase'} h-full py-2`}>
                <p className="text-base font-medium" onClick={() => setShowOptions(!showOptions)}>
                  {title}
                </p>
              </Link>
            ) : (
              <>
                <p
                  className="text-base py-2  font-medium hover:text-primary cursor-pointer"
                  onClick={() => setShowOptions(!showOptions)}
                >
                  {title}
                </p>
                <MdKeyboardArrowDown className="text-base" />
              </>
            )}
            <div
              className={`${
                showOptions ? 'flex' : 'hidden group group-hover:flex'
              } md:absolute transform md:-translate-x-1/2 left-1/2 top-[100%]
            w-full md:w-max flex-col mt-2 md:-my-1 border-t md:border md:shadow-md transition-all
          max-h-[500px] flex-wrap
             md:max-h-min bg-white rounded-md overflow-hidden
            `}
            >
              <div className="w-full max-h-[500px]">
                <div className="w-full inline-block align-top">
                  {options.map((item: any) => (
                    <div
                      className="px-4 py-3 text-sm w-full text-black hover:bg-primaryPink/20 font-medium bg-white text-left md:text-left"
                      key={item.name}
                    >
                      <Link id={item.id} to={`${item.link}`} className="inline-block w-full">
                        <span className="inline-block w-full">{item.name}</span>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <MdKeyboardArrowDown
          className={`block ml-auto mr-5 md:hidden shrink-0 ${showOptions ? 'rotate-180' : 'rotate-0'} transition-all`}
          onClick={() => setShowOptions(!showOptions)}
        />
      </div>
    </div>
  );
};

export default MenuDropDown;
